import React from 'react';
const Support = (props) => {
    let {msg } = props;
    const supData = Array.isArray(msg) ? msg[0] : msg;
    if (!supData || supData.parentId !== 11 )
    {
      return null;
    }
    return (<>
        <span className="message  message2">
            <div className="tdata" style={{ padding: '17px 10px' }}>
                <div dangerouslySetInnerHTML={{ __html: supData.htmlContent }} />
            </div>
        </span>
 
        </>
    );
};

export default Support;